/**
 * GraphQL query for topic-specific moderation statistics
 */

import { gql } from '@apollo/client';

export const GET_TOPIC_MODERATION_STATS = gql`
  query GetTopicModerationStats($communityId: ID!, $topicName: String!) {
    topicModerationStats(communityId: $communityId, topicName: $topicName) {
      topicName
      communityId
      openCasesCount
      assignedCasesCount
      inSLACases
      nearSLACases
      outOfSLACases
    }
  }
`;
